import { render, staticRenderFns } from "./OutgoingCargoOverview.vue?vue&type=template&id=4bda963a&scoped=true&"
import script from "./OutgoingCargoOverview.vue?vue&type=script&lang=js&"
export * from "./OutgoingCargoOverview.vue?vue&type=script&lang=js&"
import style0 from "./OutgoingCargoOverview.vue?vue&type=style&index=0&id=4bda963a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bda963a",
  null
  
)

export default component.exports